import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/industries', label: 'Industries' },
    { path: '/for-clients', label: 'For Clients' },
    { path: '/for-suppliers', label: 'For Suppliers' },
    { path: '/compliance', label: 'Compliance' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{ 
      backgroundColor: '#1a1c1b',
      borderBottom: '1px solid rgba(63, 72, 22, 0.5)',
      position: 'sticky',
      top: 0,
      zIndex: 50
    }}>
      <div style={{ 
        maxWidth: '87.5rem',
        margin: '0 auto',
        padding: '20px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <h1 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: '1.5rem',
            color: '#d9fb06',
            textTransform: 'uppercase',
            letterSpacing: '-0.02em'
          }}>
            Worklink Global
          </h1>
        </Link>

        {/* Desktop Navigation */}
        <nav style={{ display: 'none' }} className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              style={{
                color: isActive(link.path) ? '#d9fb06' : '#888680',
                textDecoration: 'none',
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: '1rem',
                fontWeight: 500,
                padding: '0.5em 1em',
                transition: 'color 0.3s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => e.target.style.color = '#d9fb06'}
              onMouseLeave={(e) => !isActive(link.path) && (e.target.style.color = '#888680')}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div style={{ display: 'none', gap: '12px' }} className="desktop-cta">
          <Link to="/contact?form=workforce" style={{ textDecoration: 'none' }}>
            <Button
              style={{
                background: 'transparent',
                color: '#d9fb06',
                border: '1px solid #d9fb06',
                borderRadius: '10rem',
                padding: '1em 1.5em',
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '0.9rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#d9fb06';
                e.currentTarget.style.color = '#1a1c1b';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#d9fb06';
              }}
            >
              Request Workforce
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          style={{
            display: 'block',
            background: 'transparent',
            border: 'none',
            color: '#d9fb06',
            cursor: 'pointer',
            padding: '8px'
          }}
          className="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div style={{
          backgroundColor: '#302f2c',
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              style={{
                color: isActive(link.path) ? '#d9fb06' : '#888680',
                textDecoration: 'none',
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: '1rem',
                fontWeight: 500,
                padding: '0.5em 0',
                transition: 'color 0.3s ease'
              }}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact?form=workforce" style={{ textDecoration: 'none', marginTop: '12px' }}>
            <Button
              onClick={() => setIsMobileMenuOpen(false)}
              style={{
                background: '#d9fb06',
                color: '#1a1c1b',
                border: 'none',
                borderRadius: '10rem',
                padding: '1em 1.5em',
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '1rem',
                cursor: 'pointer',
                width: '100%',
                textTransform: 'uppercase'
              }}
            >
              Request Workforce
            </Button>
          </Link>
        </div>
      )}

      <style>{`
        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
            gap: 8px;
          }
          .desktop-cta {
            display: flex !important;
          }
          .mobile-menu-toggle {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
